import { AppData, Colors, Lightning } from '@lightningjs/sdk';
import AbstractLoginModal, {
  AbstractLoginModalTemplateSpec,
  LoginFlow,
} from './layout/AbstractLoginModal';
import SignUpContent from './sign-up/SignUpContent';
import { ConfirmationType } from './confirmation/EmailConfirmationModal';

export interface SignUpInputModalTemplateSpec
  extends AbstractLoginModalTemplateSpec {
  Content: {
    Frame: object;
  } & AbstractLoginModalTemplateSpec['Content'];
}

const EMPTY_HEADING_SPACE = 89;
const INNER_CONTENT = 586;
const CONTENT_HEIGHT = INNER_CONTENT + EMPTY_HEADING_SPACE;
const CONTENT_OFFSET_Y = 229;

export default class SignUpInputModal
  extends AbstractLoginModal
  implements
    Lightning.Component.ImplementTemplateSpec<SignUpInputModalTemplateSpec>
{
  override _showBackButton = false;

  override get loginFlow() {
    return LoginFlow.SIGN_UP;
  }

  private _Frame = this._Content.getByRef('Frame')! as SignUpContent;

  static override _template(): Lightning.Component.Template<SignUpInputModalTemplateSpec> {
    const { Content, ...rest } = super._template();
    return {
      Content: {
        ...Content,
        flex: {
          direction: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center',
        },
        y: CONTENT_OFFSET_Y,
        h: CONTENT_HEIGHT,
        Frame: {
          type: SignUpContent,
          h: INNER_CONTENT,
          w: Content!.w,
          rect: true,
          color: Colors('loginBackground').get(),
          signals: {
            $onSignUpHovered: '$onSignUpHovered',
            $onSignUpLink: '$onSignUpLink',
            $onCreatePassword: '$onCreatePassword',
            $openKeyboard: '$openKeyboard',
            $resetToEmailInput: true,
          },
        },
      },
      ...rest,
    };
  }

  modalInit(data: { email: string }) {
    this._Frame.email = data?.email;
  }

  override _getFocused() {
    return this._Frame;
  }

  private $onSignUpHovered() {
    this._setState('Content');
  }

  private async $onSignUpLink(args: { email: string; optIn: boolean }) {
    const smartLoginService = AppData?.smartLoginService;
    if (!smartLoginService) return;

    const { email, optIn } = args;
    const linkSent = await this.onLoading(
      smartLoginService.sendSignUpEmail(email, optIn),
    );

    if (linkSent) {
      AppData?.modalService.open('EmailConfirmationModal', {
        data: { email: args.email, confirmationType: ConfirmationType.SIGN_UP },
      });
    }
  }

  private $onCreatePassword(email: string) {
    AppData?.modalService.open('CreatePasswordModal', {
      data: { email },
    });
  }
}
